module.exports = __webpack_public_path__ + "static/img/hummer.2d1176fc.png";